module.exports = __webpack_public_path__ + "img/footer_wechat.b67e6cdb.png";